import { render, staticRenderFns } from "./PollEditorNumberSlider.vue?vue&type=template&id=98bb4d42&scoped=true"
import script from "./PollEditorNumberSlider.vue?vue&type=script&lang=js"
export * from "./PollEditorNumberSlider.vue?vue&type=script&lang=js"
import style0 from "./PollEditorNumberSlider.vue?vue&type=style&index=0&id=98bb4d42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bb4d42",
  null
  
)

export default component.exports